module.exports = __webpack_public_path__ + "img/placeholder1.fac11307.png";